/**
 * Hulpfuncties voor het eigen datumveld.
 *
 * De app gebruikt intern ISO (`jjjj-mm-dd`); de gebruiker ziet en typt
 * `dd-mm-jjjj`. Deze vertaling staat los van het component zodat ze apart
 * getest kan worden.
 */

export function toDutchDate(iso: string) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(iso)) return "";
  const [year, month, day] = iso.split("-");
  return `${day}-${month}-${year}`;
}

/** Leest `dd-mm-jjjj` en varianten met `/` of `.`; geeft ISO of "" terug. */
export function parseDutchDate(value: string) {
  const match = value.trim().match(/^(\d{1,2})[-/.](\d{1,2})[-/.](\d{4})$/);
  if (!match) return "";
  const [, day, month, year] = match;
  const iso = `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
  const parsed = new Date(`${iso}T12:00:00Z`);
  // Een niet-bestaande datum als 31-02 rolt door naar maart; dat weigeren we.
  return parsed.getUTCDate() === Number(day) &&
    parsed.getUTCMonth() + 1 === Number(month)
    ? iso
    : "";
}

export function toIsoDate(date: Date) {
  const month = `${date.getMonth() + 1}`.padStart(2, "0");
  const day = `${date.getDate()}`.padStart(2, "0");
  return `${date.getFullYear()}-${month}-${day}`;
}

/**
 * Het 6x7-raster voor de maand van `reference`, met maandag als eerste dag.
 * `getDay()` geeft zondag 0, dus schuiven we een dag op.
 */
export function mondayFirstMonthGrid(reference: Date) {
  const first = new Date(reference.getFullYear(), reference.getMonth(), 1);
  const leading = (first.getDay() + 6) % 7;
  const start = new Date(first);
  start.setDate(first.getDate() - leading);
  return Array.from({ length: 42 }, (_, index) => {
    const day = new Date(start);
    day.setDate(start.getDate() + index);
    return day;
  });
}
